import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { isNil } from 'ramda';
import FormattedCurrency from 'components/ui/FormattedCurrency';
import { StyledCellContent } from '../ClickableCell.styles';

const CellContent = ({
  isTimeRestricted,
  isExistingTrain,
  canBeBooked,
  hasAvailableFares,
  cappedTrainFreeSeats,
  displayPrice,
  currency,
  loyaltyPoints,
  hasAnimalsSoldOut,
  isExchangingSingleSNLegOfASummatedFare = false,
  isExchangingSNCBLeg = false,
  fromSNSummatedToSNSummated = false,
  hasLuggageSoldOut = false,
  children
}) => {
  switch (true) {
    case isExistingTrain:
      return <FormattedMessage id="searchResults.yourTrain" />;
    case isTimeRestricted:
      return <FormattedMessage id="searchResults.insufficientTime" />;
    case !canBeBooked:
      return <FormattedMessage id="searchResults.cannotBeBooked" />;
    case !hasAvailableFares && !cappedTrainFreeSeats:
      return <FormattedMessage id="searchResults.noSeatsLeft" />;
    case hasAnimalsSoldOut:
      return <FormattedMessage id="assistanceAnimals.animalsSoldOut" />;
    case hasLuggageSoldOut:
      return <FormattedMessage id="searchResults.luggageSoldOut" />;
    default:
      return (
        <StyledCellContent>
          <div>
            <FormattedCurrency
              currency={currency}
              amount={
                (isExchangingSingleSNLegOfASummatedFare || isExchangingSNCBLeg || fromSNSummatedToSNSummated) && displayPrice < 0
                  ? Math.abs(displayPrice)
                  : displayPrice
              }
              hideEmptyDecimals
            />
          </div>
          {!isNil(loyaltyPoints) && (
            <div data-cy="loyalty-points">
              <FormattedMessage id="searchResults.pts" values={{ points: loyaltyPoints }} />
            </div>
          )}

          {!hasAvailableFares && cappedTrainFreeSeats && (
            <>
              <div data-cy="capped-train-message">
                <FormattedMessage id="flowForward.cappedTrain" />
              </div>
            </>
          )}

          {children}
        </StyledCellContent>
      );
  }
};

CellContent.propTypes = {
  loyaltyPoints: PropTypes.number,
  isTimeRestricted: PropTypes.bool,
  isExistingTrain: PropTypes.bool,
  canBeBooked: PropTypes.bool,
  hasAvailableFares: PropTypes.bool,
  cappedTrainFreeSeats: PropTypes.bool,
  displayPrice: PropTypes.number,
  currency: PropTypes.string.isRequired,
  hasAnimalsSoldOut: PropTypes.bool,
  isExchangingSingleSNLegOfASummatedFare: PropTypes.bool,
  isExchangingSNCBLeg: PropTypes.bool,
  fromSNSummatedToSNSummated: PropTypes.bool,
  hasLuggageSoldOut: PropTypes.bool,
  children: PropTypes.node
};

export default CellContent;
